export default "__VITE_ASSET__JrmPv4bl__"